<template>
  <div>
    <template
      v-if="
        registration.registrationGrooms &&
        registration.registrationGrooms.length
      "
    >
      <template
        v-for="(groom, i) in registration.registrationGrooms"
        :key="groom.id"
      >
        <AppShowPersonName
          :person="{ id: groom.personId, name: groom.personName }"
        />{{ i != registration.registrationGrooms.length - 1 ? ", " : "" }}
      </template>
    </template>
    <template v-else>
      {{ registration.groomNames }}
    </template>
  </div>
</template>
<script>
import gql from "fraql";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";

export default {
  name: "AppShowDrivingGrooms",
  components: {
    AppShowPersonName
  },
  props: {
    registration: {
      type: Object,
      required: true
    }
  },
  fragments: {
    registrationFields: gql`
      fragment _ on Registration {
        groomNames
        registrationGrooms {
          id
          personId
          personName
        }
      }
    `
  }
};
</script>
